import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/Button";

export default function Forbidden() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 bg-cream text-center">
      <ShieldAlert className="h-8 w-8 text-danger-500" />
      <h1 className="text-xl font-semibold text-ink">You don't have access to this page</h1>
      <p className="text-ink-muted">Ask a Super Admin to grant your role permission.</p>
      <Link to="/dashboard">
        <Button variant="outline">Back to dashboard</Button>
      </Link>
    </div>
  );
}
